module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "NewsFooter"
  }, [_c('div', {
    staticClass: "NewsFooter-search"
  }, [_c('news-search')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79634366"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsFooter.vue
// module id = 781
// module chunks = 1474